import {ReactTabulator} from "react-tabulator";
import {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";

const Index = ({tableOptions, tableType, newFormData, onSubmit}) => {

    let customValueToShowFields = ""
    if (tableType === "بدهکار") {
        customValueToShowFields = "bed"
    } else {
        customValueToShowFields = "bes"

    }

    // let detailsData = [];
    const [detailsData, setDetailsData] = useState([])

    useEffect(() => {
        if (newFormData.length > 0) {
            let temp = [];
            //debugger;
            for (let v of newFormData) {
                temp.push({
                    text: v.reference,
                    value: v.ref,
                    type: v.referenceType
                })
            }
            // make array uniq delete Duplicate
            let uniqueArray = temp.filter((value, index) => {
                const _value = JSON.stringify(value);
                return index === temp.findIndex(obj => {
                    return JSON.stringify(obj) === _value;
                });
            });
            let tempHere = uniqueArray.filter(v => v.reference !== "-")
            // //debugger;
            setDetailsData(tempHere);
        }
    }, []);


    const randomNumber = Math.random() * 1000;
    const ReactTabulatorRef = useRef(null);
    const moinRef = useRef(null);
    const indexRef = useRef(null);
    const valueRef = useRef(null);
    const paramRef = useRef(null);
    const selectFieldRef = useRef(null);
    const hasConditionRef = useRef(null);
    const [tableData, setTableData] = useState([]);


    const tableColumns = [
        {
            title: "معین بکی",
            field: "key",
            headerSort: false,
        },
        {
            title: "معین",
            field: "keyToShow",
            headerSort: false,
        },
        {
            title: "فیلد شاخص",
            field: "main",
            headerSort: false,
        },

        {
            title: "شرط",
            field: "hasConditionField",
            headerSort: false,
        },
        {
            title: "واسه بک",
            field: "condition",
            headerSort: false,
            visible: true,

        },

        {
            title: "فیلد انتخابی",
            field: "field",
            headerSort: false,
        },
        {
            title: "پارامتر بک",
            field: "operator",
            headerSort: false,
        },
        {
            title: "پارامتر",
            field: "operatorToShow",
            headerSort: false,
        },
        {
            title: "مقدار",
            field: "value",
            headerSort: false,
        },
        {
            title: "حذف",
            headerSort: false,
            formatter: "buttonCross", width: 90, align: "center", cellClick: function (e, cell) {
                cell.getRow().delete();

                let tableDataPlease = ReactTabulatorRef.current.table.getData();
                if (customValueToShowFields === "bed") {
                    onSubmit({bed: tableDataPlease})
                } else {
                    onSubmit({bes: tableDataPlease})
                }

            }
        },
    ];


    const [isCheckedCondition, setIsCheckedCondition] = useState(false);

    function onChangeConditionCheckBox(event) {
        console.log(event);
        setIsCheckedCondition(event.target.checked);
    }


    function resetForm() {
        moinRef.current.value = '0'
        indexRef.current.value = 'nullSelect'
        hasConditionRef.current.checked = false;
        setIsCheckedCondition(false);
        if (selectFieldRef.current) selectFieldRef.current.value = '0'
        if (paramRef.current) paramRef.current.value = '0'
        if (valueRef.current) valueRef.current.value = '0'

    }

    const addRowHandler = () => {

        if (moinRef.current.value === '0') {
            toast.error("انتخاب معین اجباری است.");
            return;
        }
        if (indexRef.current.value === 'nullSelect') {
            toast.error("انتخاب فیلد شاخص اجباری است.");
            return;
        }
        const op = valueRef.current!==null ? valueRef.current.value : "";
        if (op.includes('+') ||
            op.includes('-') ||
            op.includes('*') ||
            op.includes('=') ||
            op.includes('<') ||
            op.includes('>') ||
            op.includes('<=') ||
            op.includes('>=') ||
            op.includes('!=') ||
            op.includes('!==') ||
            op.includes('~') ||
            op.includes('\'') ||
            op.includes('"')
        ) {
            toast.error("استفاد از عملگر در فیلد مقدار مجاز نیست.");
            return;
        }

        let conditionLabel = hasConditionRef.current.checked ? "دارد" : "ندارد";

        //debugger;
        let objectToAdd = {
            key: moinRef.current.value,
            keyToShow: moinRef.current.options[moinRef.current.selectedIndex].text,
            main: indexRef.current.options[indexRef.current.selectedIndex].text,
            hasConditionField: conditionLabel,
            condition: hasConditionRef.current.checked,
            field: selectFieldRef.current ? selectFieldRef.current.options[selectFieldRef.current.selectedIndex].text : "-",
            operator: paramRef.current ? paramRef.current.value : "-",
            operatorToShow: paramRef.current ? paramRef.current.options[paramRef.current.selectedIndex].text : "-",
            value: valueRef.current ? valueRef.current.value : "-",
        }

        if (hasConditionRef.current.checked) {

            if (selectFieldRef.current.value === 'nullSelect') {
                toast.error("انتخاب فیلد بعد از تیک شرط اجباری است");
                return;
            }
            if (paramRef.current.value === '0') {
                toast.error("انتخاب فیلد پارامتر اجباری است.");
                return;
            }
            if (valueRef.current.value === '') {
                toast.error("انتخاب فیلد مقدار اجباری است.");
                return;
            }
        }

        let tempDataTabulator = [];

        let tableDataPlease = ReactTabulatorRef.current.table.getData();

        if (tableDataPlease.length > 0) {
            tableDataPlease.map(v => {
                // اگه تکراری بود میشه لطفا اجازه ندی به جدول اضافه بشه؟
                if (JSON.stringify(v) === JSON.stringify(objectToAdd)) {
                    toast.error("این مورد قبلا به جدول اضافه شده است.");
                    throw new Error("این مورد قبلا به جدول اضافه شده است.");
                }
                tempDataTabulator.push({
                    key: v.key,
                    keyToShow: v.keyToShow,
                    main: v.main,
                    hasConditionField: v.hasConditionField,
                    condition: v.condition,
                    field: v.field,
                    operator: v.operator,
                    operatorToShow: v.operatorToShow,
                    value: v.value,
                });
            });
            tempDataTabulator.push(objectToAdd);
        } else {
            tempDataTabulator.push(objectToAdd);
        }


        setIsCheckedCondition(false);
        setTableData(tempDataTabulator);
        if (customValueToShowFields === "bed") {
            onSubmit({bed: tempDataTabulator})
        } else {
            onSubmit({bes: tempDataTabulator})
        }
        resetForm();

    }
    console.log("newFormData")
    console.log(newFormData)
    console.log("detailsData")
    console.log(detailsData)
    return (
        <>

            <div className={"d-flex flex-column  align-content-center justify-content-center"}>

                <div>
                    <ReactTabulator ref={ReactTabulatorRef}
                                    columns={tableColumns}
                                    data={tableData}
                                    options={tableOptions}
                    />
                </div>
                <div className={""} style={
                    {
                        "display": "flex",
                        "flex-direction": "column",
                        "align-items": "center"
                    }
                }>


                    <div className="selectBox-sides">
                        <label htmlFor="id1" className="control-lable form-label">انتخاب معین :</label>
                        <select defaultValue={"0"} ref={moinRef} className="inputBox" id="id1">
                            <option value="0">گزینه مورد نظر خود را انتخاب کنید</option>
                            {/* باید اینجا  مقدار دیتا رو حسابی فیلتر کنم و متناسببا معین  از قبلی اطلاعات رو نمایش بدم.*/}
                            {/*{detailsData.map((v, index) => (<option key={index} value={v.value}> {v.text}</option>))}*/}
                            {/*    for (const el of detailsData) {*/}
                            {/*    if(el.type===customValueToShowFields){*/}
                            {/*    // eslint-disable-next-line react-hooks/exhaustive-deps*/}
                            {/*    optionsToShowMoein+=<option value={el.value}>{el.text}</option>*/}
                            {/*}*/}
                            {/*}*/}


                            {detailsData.map((v, index) => v.text !== "-" &&
                                <option key={index} value={v.value}> {v.text}</option>)}


                            {/*{detailsData.map((v, index) => (<option key={index} value={v.value}> {v.text}</option>))}*/}


                            {/*{tableType === "بدهکار" ?*/}
                            {/*detailsData.bed.map(v=> <option key={v.key} value={v.key} >{v.name}</option>)*/}
                            {/*    :*/}
                            {/*detailsData.bes.map(v=> <option key={v.key} value={v.key} >{v.name}</option>)*/}
                            {/*}*/}
                        </select>
                    </div>


                    <div className="selectBox-sides">
                        <label htmlFor="id1" className="control-lable form-label">فیلد شاخص :</label>
                        <select ref={indexRef} className="inputBox" id="id1">
                            <option value="nullSelect" selected="">گزینه مورد نظر خود را انتخاب کنید</option>
                            {newFormData.map((v, index) => (v.type === "مبلغ" &&
                                <option key={index} value={index}> {v.name}</option>))}
                        </select>
                    </div>

                    <div className="selectBox-sides">
                        <div className="CheckBOX">
                            <input
                                ref={hasConditionRef}
                                defaultChecked={isCheckedCondition}
                                onChange={(e) => onChangeConditionCheckBox(e)}
                                className="form-check-input" type="checkbox" value="" id={"0" + randomNumber} name=""
                            />
                            <label className="" htmlFor={"0" + randomNumber}>
                                شرط
                            </label>
                        </div>
                    </div>

                    {isCheckedCondition === true
                        ?
                        <>
                            <div className="selectBox-sides">
                                <label htmlFor="id1" className="control-lable form-label">انتخاب فیلد:</label>
                                <select defaultValue={"nullSelect"} ref={selectFieldRef} className="inputBox w-100"
                                        id="id1">
                                    <option value="nullSelect">گزینه مورد نظر خود را انتخاب کنید.</option>
                                    {/*{newFormData.map((v,index)=> (<option value = {index} > {v.name}</option>)) }*/}
                                    {newFormData.map((v, index) => (/*v.referenceType === customValueToShowFields &&*/
                                        <option key={index} value={index}> {v.name}</option>))}


                                </select>
                            </div>
                            <div className="selectBox-sides">
                                <label htmlFor="id1" className="control-lable form-label">پارامتر:</label>
                                <select ref={paramRef} className="inputBox" id="id1">
                                    <option value="0" selected="">گزینه مورد نظر خود را انتخاب کنید</option>
                                    <option value="=">مساوی</option>
                                    <option value="<">کوچیکتر</option>
                                    <option value=">">بزرگتر</option>
                                    <option value=">=">بزرگتر مساوی</option>
                                    <option value="<=">کوچیکتر مساوی</option>

                                </select>
                            </div>
                            <div className="selectBox-sides">
                                <label htmlFor="InputName" className="control-lable form-label">مقدار </label>
                                <input
                                    ref={valueRef}
                                    type="text"
                                    className="form-control inputBox"
                                    id=""
                                    name=""
                                    defaultValue=""

                                    autoComplete="off"
                                    maxLength="11"
                                    placeholder="متن مورد نظر خود را وارد کنید"
                                    required=""
                                    onChange={e => e.target.value}
                                />
                                <label className="error-msg"></label>
                            </div>
                        </>
                        :
                        <div className={"badge bg-secondary"}>
                            بدون شرط
                        </div>
                    }
                </div>
                <div className="button-box mb-4">
                    <button type="submit" className="mx-auto mt-5" onClick={addRowHandler}>افزودن به جدول</button>
                </div>
            </div>
        </>
    );


};

export default Index;